<template>
  <div>
    <a class="psg__trigger" href="#" @click.prevent="$refs.sizeChart.open()">Size Guide</a>
    <portal to="pdp-modal-portal">
      <modal ref="sizeChart" class="psg__modal">
        <div slot="content" v-html="content"></div>
      </modal>
    </portal>
  </div>
</template>

<script>
import Modal from '@/scripts/components/basic/Modal.vue'

export default {
  name: 'ProductSizeGuide',
  props: {
    content: String
  },
  components: {
    Modal
  }
}
</script>

<style scoped lang="scss">
.psg {
  &__trigger {
    font-size: rem(13);
    font-weight: 400;
    line-height: 15px;
    color: $color-black;
    text-decoration: underline;
    position: absolute;
    top: 3px;
    right: 0;
    z-index: 3;
    cursor: pointer;
    @include mobile-only {
      font-size: rem(10);
    }
  }

  &__modal {
    /deep/ .modal__content {
      padding: 44px 60px 56px 60px;
    }
  }

}
</style>